import Spinner from "components/Spinner";
import React, { Suspense, lazy } from "react";
import useUserStore from "store/user";
const CRM = lazy(() => import("components/home/crm"));
const SuperAdminCrm = lazy(() => import("components/CRM/superadmin.crm"));
const SuperintCrm = lazy(() => import("components/CRM/superint.crm"));
const SpecialUserCRM = lazy(() => import("components/CRM/specialuser.crm"));
const SpecialSecretaryCRM = lazy(() =>
  import("components/CRM/specialsecretary.crm")
);

const Member = () => {
  const { user } = useUserStore();

  return (
    <Suspense fallback={<Spinner />}>
      {user?.role === "superadmin" ? (
        <SuperAdminCrm />
      ) : user?.role === "superintendent" ? (
        <SuperintCrm />
      ) : user?.roleType === "specialuser" ? (
        <SpecialUserCRM />
      ) : user?.roleType === "specialsecretary" ? (
        <SpecialSecretaryCRM />
      ) : (
        <CRM />
      )}
    </Suspense>
  );
};

export default Member;
